module.exports = __webpack_public_path__ + "static/media/banner3.6eb872cd.jpg";